import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from './config';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    configLoaded: false,
    user: {},
    games: [],
    achievements: [],
    providers: [],
    game_tags: [],
    gamesMap: {},
    providersMap: {},
    actions: [],
    actionsMap: {},
    languages: [],
    jackpots: [],
    jackpotsMap: [],
    tournaments: [],
    tournamentsMap: [],
    languagesMap: {},

    groups: [],
    groupsMap: {},

    additional_fields: [],
    additional_fieldsMap: {},

    periods: [
      {key: 'Hourly', value: 'hour'},
      {key: 'Daily', value: 'day'}
    ],
    game_picks: [
      {key: 'Single', value: 'single'},
      {key: 'Multi', value: 'multi'},
      {key: 'All', value: 'all'}
    ],
    game_options: [
      {key: 'None', value: 'none'},
      {key: 'Unique', value: 'unique'}
    ],
    webhookEvents: [
      {value: 'awarded', label: 'Achievement Complete'}
    ],
    apikeyTypes: [
      {value: 'full', label: 'Full Access'},
      {value: 'web', label: 'Web Access'}
    ],
    clients: [
      {value: 'casino1', label: 'First Casino'}
    ],
    gameTypes: [],
    wkDays: [
      {key: 'MON', value: '1'},
      {key: 'TUE', value: '2'},
      {key: 'WED', value: '3'},
      {key: 'THU', value: '4'},
      {key: 'FRI', value: '5'},
      {key: 'SAT', value: '6'},
      {key: 'SUN', value: '7'},
    ],
  },

  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    configLoaded(state) {
      state.configLoaded = true
    },
    auth_success(state, token, user) {
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
    },
    games(state, data) {
      state.games = data
    },
    achievements(state, data) {
      state.achievements = data
    },
    providers(state, data) {
      state.providers = data
    },
    tournaments(state, data) {
      state.tournaments = data
    },
    jackpots(state, data) {
      state.jackpots = data
    },
    game_tags(state, data) {
      state.game_tags = data
    },
    actions(state, data) {
      state.actions = data
    },
    languages(state, data) {
      state.languages = data
    },
    groups(state, data) {
      state.groups = data
    },
    additional_fields(state, data) {
      state.additional_fields = data
    },
    gamesMap(state, data) {
      state.gamesMap = data
    },
    providersMap(state, data) {
      state.providersMap = data
    },
    tournamentsMap(state, data) {
      state.tournamentsMap = data
    },
    jackpotsMap(state, data) {
      state.jackpotsMap = data
    },
    game_tagsMap(state, data) {
      state.game_tagsMap = data
    },
    actionsMap(state, data) {
      state.actionsMap = data
    },
    languagesMap(state, data) {
      state.languagesMap = data
    },
    groupsMap(state, data) {
      state.groupsMap = data
    },
    additional_fieldsMap(state, data) {
      state.additional_fieldsMap = data
    },
    gameTypes(state, data) {
      state.gameTypes = data
    },
  },

  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  },

  actions: {
    login({ commit }, user) {

      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: config.API_URL + '/users/login', data: user, method: 'POST' })
          .then(resp => {
            const token = resp.data.token
            const user = { name: resp.data.user }
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', token, user)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      localStorage.removeItem('token');
      commit('logout');
    },
    config({ commit, state }) {

      return new Promise((resolve, reject) => {

        axios({ url: config.API_URL + '/settings/config', method: 'GET' })
          .then(resp => {

            if (resp.data) {
              
              commit('providers', resp.data.data.providers);
              commit('tournaments', resp.data.data.tournaments);
              commit('jackpots', resp.data.data.jackpots);
              commit('game_tags', resp.data.data.game_tags);
              commit('actions', resp.data.data.actions);
              commit('languages', resp.data.data.languages);
              commit('groups', resp.data.data.groups);
              commit('additional_fields', resp.data.data.additional_fields);

              let gameTypes = {}
              commit('gamesMap', resp.data.data.games.reduce(function (map, obj) {
                map[obj._id] = obj;
                gameTypes[obj.type] = 1;
                return map;
              }, {}));

              commit('gameTypes', Object.keys(gameTypes));
              
              commit('providersMap', resp.data.data.providers.reduce(function (map, obj) {
                map[obj._id] = obj;
                return map;
              }, {}));


              commit('games', resp.data.data.games.reduce(function (arr, obj) {
                obj.name_with_provider = obj.name + ' (' + state.providersMap[obj._provider_id].name + ') [' + obj.id + ']';
                arr.push(obj);
                return arr;
              }, []));

              commit('tournamentsMap', resp.data.data.tournaments.reduce(function (map, obj) {
                map[obj._id] = obj;
                return map;
              }, {}));

              commit('jackpotsMap', resp.data.data.jackpots.reduce(function (map, obj) {
                map[obj._id] = obj;
                return map;
              }, {}));

              commit('game_tagsMap', resp.data.data.game_tags.reduce(function (map, obj) {
                map[obj._id] = obj;
                return map;
              }, {}));

              commit('actionsMap', resp.data.data.actions.reduce(function (map, obj) {
                map[obj.value] = obj;
                return map;
              }, {}));

              commit('languagesMap', resp.data.data.languages.reduce(function (map, obj) {
                map[obj._id] = obj;
                return map;
              }, {}));

              commit('groupsMap', resp.data.data.groups.reduce(function (map, obj) {
                map[obj._id] = obj;
                return map;
              }, {}));

              commit('additional_fieldsMap', resp.data.data.additional_fields.reduce(function (map, obj) {
                map[obj._id] = obj;
                return map;
              }, {}));

            }

            resolve();
                       
          })
          .catch(err => {
            console.error(err)
          })
      })
    },

    config_achievements({ commit }) {

      return new Promise((resolve, reject) => {

        axios({ url: config.API_URL + '/settings/achievements', method: 'GET' })
          .then(resp => {
            if (resp.data) {
              commit('achievements', resp.data.data);
            }

            resolve();
                       
          })
          .catch(err => {
            console.error(err)
          })
      })
    },

  }
})
